export const getContextPath = (pathname, contextPaths) => {
  for (const contextPath of contextPaths) {
    if (contextPath && contextPath !== '/' && pathname.startsWith(contextPath)) {
      return contextPath;
    }
  }
  return '';
};
